import { GridRowSelectionModel } from '@mui/x-data-grid';
import { api, BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('/nnc/failuremode');
  }
  unfounded = async (ids: GridRowSelectionModel, justification: string) => {
    return api.post(this.buildUrl('unfounded'), {
      ids: ids,
      justification: justification,
    });
  };
}

export default new API();
